import React from 'react'
import { ModuleHeader } from '../module-header'
import { StyledFinishedExamsCardWrapper } from './finished-exams.style'
import FinishedExamsItem from './finished-exams-item'

const FinishedExams = () => {
    return (
        <>
            <ModuleHeader title="FINISHED EXAMS" />
            <StyledFinishedExamsCardWrapper>
                <FinishedExamsItem />
                <FinishedExamsItem />
                <FinishedExamsItem />
            </StyledFinishedExamsCardWrapper>
        </>
    )
}

export { FinishedExams }
